import { render, staticRenderFns } from "./StudentCourseEdit.vue?vue&type=template&id=b369417c&scoped=true"
import script from "./StudentCourseEdit.vue?vue&type=script&lang=js"
export * from "./StudentCourseEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b369417c",
  null
  
)

export default component.exports